import { render, staticRenderFns } from "./SeatZone.vue?vue&type=template&id=24d193d4&"
import script from "./SeatZone.vue?vue&type=script&lang=js&"
export * from "./SeatZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports